<!-- 
CategoryEdit.vue
功能：編輯名單
作者：i9400538 陳博承
完成：2021-06-17
-->
<template>
  <main>
    <tab-header />
    <div class="tab-pane active show">
      <form class="form">
        <section class="segment" @input="markAsEdited" @change="markAsEdited">
          <div class="row" :class="{ 'readonly-mode': isReadOnlyMode() }">
            <!-- 輸入人員-->
            <div class="col-12">
              <div class="form-group row">
                <label for="dev_name" class="col-2 text-right">輸入人員</label>
                <div class="col-2 d-flex">
                  <label class="f-w-5">{{form.input_name}}</label>
                </div>
              </div>
            </div>
            <!-- 大類-->
            <div class="col-12">
              <div class="form-group row">
                <label for="category" class="col-2 text-right">大類</label>
                <div class="col-1">
                  <select
                    :id="`category-${colKey}`"
                    :data-vv-name="`category-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="大類"
                    class="form-control select-width"
                    :class="{ 'is-invalid': errors.has(`category-${colKey}`) }"
                    v-model="form.category"
                    @change="initSubcategoryOpt(false)"
                  >
                    <option value>請選擇</option>
                    <option
                      v-for="(item, index) in categoryOpt"
                      :key="index"
                      :value="item.category"
                    >{{item.category}}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- 中類-->
            <div class="col-12">
              <div class="form-group row">
                <label for="wg_name" class="col-2 text-right">中類</label>
                <div class="col-1">
                  <select
                    :id="`subcategory-${colKey}`"
                    :data-vv-name="`subcategory-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="中類"
                    class="form-control select-width"
                    :class="{ 'is-invalid': errors.has(`subcategory-${colKey}`) }"
                    v-model="form.subcategory"
                    @change="initOrderOpt"
                  >
                    <option value>請選擇</option>
                    <option
                      v-for="(item, index) in subCategoryOpt"
                      :key="index"
                      :value="item.subcategory"
                    >{{item.subcategory}}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- 名單名稱-->
            <div class="col-12">
              <div class="form-group row">
                <label for="dev_name" class="col-2 text-right">名單名稱</label>
                <div class="col-2 d-flex">
                  <input
                    type="text"
                    maxlength="24"
                    :id="`category-name-${colKey}`"
                    :data-vv-name="`category-name-${colKey}`"
                    placeholder="請輸入名單名稱"
                    v-validate="'required|checkCategoryNameIsExist|checkCategoryNameSize'"
                    data-vv-as="名單名稱"
                    class="form-control"
                    v-model="form.category_name"
                    alt="ch"
                    :class="{ 'is-invalid': errors.has(`category-name-${colKey}`) }"
                    @input="checkInputCategoryName"
                  />
                </div>
              </div>
            </div>
            <!-- 是否為季辦法-->
            <div class="col-12">
              <div class="form-group row">
                <label class="col-2 text-right">是否為季辦法</label>
                <div class="col-4 d-flex">
                  <div class="radio radio-inline">
                    <input type="radio" name="isquarterly" id="isquarterly-Y" v-model="form.isquarterly" value="Y">
                    <label for="isquarterly-Y">是（顯示於最新上架）</label>
                  </div>
                  <div class="radio radio-inline">
                    <input type="radio" name="isquarterly" id="isquarterly-N" v-model="form.isquarterly" value="N">
                    <label for="isquarterly-N">否</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 上架日期 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="upload_date" class="col-2 text-right">上架日期</label>
                <div class="col-10 d-flex">
                  <select
                    :id="`upload-year-${colKey}`"
                    :data-vv-name="`upload-year-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="上架日期"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`upload-year-${colKey}`) }"
                    v-model="form.upload_date[0]"
                    @change="updateDate('upload',form.upload_date[0], form.upload_date[1])"
                  >
                    <option value>年份</option>
                    <option
                      v-for="(opt, y_opt_i) in yearOpt_upload"
                      :key="`upload-year-${y_opt_i}`"
                      :value="opt"
                    >{{opt - 1911}}年</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`upload-month-${colKey}`"
                    :data-vv-name="`upload-month-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="上架日期"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`upload-month-${colKey}`) }"
                    v-model="form.upload_date[1]"
                    @change="updateDate('upload',form.upload_date[0], form.upload_date[1])"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`upload-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`upload-date-${colKey}`"
                    :data-vv-name="`upload-date-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="上架日期"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`upload-date-${colKey}`) }"
                    v-model="form.upload_date[2]"
                    @change="updateDate('upload',form.upload_date[0], form.upload_date[1])"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_upload"
                      :key="`upload-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>
                </div>
              </div>
            </div>
            <!--下架日期 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="end-year" class="col-2 text-right">下架日期</label>
                <div class="col-6">
                  <select
                    @change="updateDate('end',form.end_date[0], form.end_date[1])"
                    name="end-year"
                    id="end-year"
                    class="form-control form-control-inline"
                    v-model="form.end_date[0]"
                  >
                    <option value>年份</option>
                    <option
                      v-for="(opt, y_opt_i) in yearOpt_end"
                      :key="`end-year-${y_opt_i}`"
                      :value="opt"
                    >{{opt - 1911}}年</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    @change="updateDate('end',form.end_date[0], form.end_date[1])"
                    name="end-month"
                    id="end-month"
                    class="form-control form-control-inline"
                    v-model="form.end_date[1]"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`end-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    @change="updateDate('end',form.end_date[0], form.end_date[1])"
                    name="end_date"
                    id="end-date"
                    class="form-control form-control-inline"
                    v-model="form.end_date[2]"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_end"
                      :key="`end-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>
                  &nbsp;&nbsp;
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="form.noEndDate" id="chk-no-end-date" />
                    <label for="chk-no-end-date">無下架日期</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 教案附件 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="upload_file" class="col-2 text-right">教案附件</label>

                <div class="col-10 d-flex">
                  <div v-if="initUploadFile && !isDelete">
                    <span class="text">{{initUploadFile}}</span>
                    <button type="button" class="btn btn-red delete-btn" @click="doDelete">刪除</button>
                  </div>
                  <div class="d-flex" v-else>
                    <input id="file-upload" ref="myFiles" type="file" @change="changeInput()" />
                    <input
                      type="text"
                      v-model="form.upload_file"
                      id="file-text"
                      class="form-control w-50 mr-2"
                      placeholder="請上傳附件"
                      readonly
                    />
                    <label for="file-upload" class="custom-file-upload btn btn-default m-0">上傳檔案</label>
                  </div>
                  <span v-if="!form.upload_file" class="text-red span-margin-top">附件不得超過5MB</span>
                </div>
              </div>
            </div>
            <!-- 說明1 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="description" class="col-2 text-right">說明1</label>
                <div class="col-10 d-flex">
                  <input
                    v-model="form.description"
                    class="form-control"
                    rows="5"
                    maxlength="150"
                    @input="checkInputDescription('description')"
                  >
                </div>
                <label for="description" class="col-2 text-right"></label>
              </div>
            </div>
            <!-- 說明2 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="description2" class="col-2 text-right">說明2</label>
                <div class="col-10 d-flex">
                  <input
                    v-model="form.description2"
                    class="form-control"
                    rows="5"
                    maxlength="150"
                    @input="checkInputDescription('description2')"
                  >
                </div>
                <label for="description" class="col-2 text-right"></label>
              </div>
            </div>
            <!-- 說明3 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="description3" class="col-2 text-right">說明3</label>
                <div class="col-10 d-flex">
                  <input
                    v-model="form.description3"
                    class="form-control"
                    rows="5"
                    maxlength="150"
                    @input="checkInputDescription('description3')"
                  >
                </div>
                <label for="description" class="col-2 text-right"></label>
                <div class="col-10 d-flex text-darkgray">
                  <span>限150個字(中文、英文、數字、符號、空格)，目前已輸入{{form.description.length + form.description2.length + form.description3.length}}個字(包含紅字程式碼)。若字型要顯示紅字，內文請加：黑字$reds這裡顯示紅字$rede黑字</span>
                </div>     
              </div>
            </div>
            <div class="col-12" v-if="overCharacterLimit">
              <div class="form-group row">
                <label for="description" class="col-2 text-right"></label>
                <div class="col-10 d-flex">
                  <span class="text-red">輸入總字數限制150字！</span>
                </div>     
              </div>
            </div>      
            <!-- 名單次序 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="description" class="col-2 text-right">名單次序</label>
                <div class="col-1">
                  <select
                    v-model="form.category_name_order"
                    class="form-control select-width"
                    :disabled="!isUsing"
                  >
                    <option value>請選擇</option>
                    <option
                      v-for=" (n , index) in parseInt(orderCount)"
                      :key="index"
                      :value="n"
                    >{{n}}</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 維護單位-->
            <div class="col-12">
              <div class="form-group row">
                <label for="dev_name" class="col-2 text-right">維護單位</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="10"
                    :id="`dev_name-${colKey}`"
                    :data-vv-name="`dev_name-${colKey}`"
                    placeholder="請輸入維護單位"
                    v-model="form.dev_name"
                    v-validate="'required'"
                    data-vv-as="維護單位"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has(`dev_name-${colKey}`) }"
                    alt="ch"
                    @input="checkInputDevName"
                  />
                </div>
              </div>
            </div>
            <!-- 聯絡電話-->
            <div class="col-12">
              <div class="form-group row">
                <label for="contact" class="col-2 text-right">聯絡電話</label>
                <div class="col-8">
                  <span class="text">(</span>
                  <input
                    type="tel"
                    maxlength="3"
                    :id="`contact-0-${colKey}`"
                    :data-vv-name="`contact-0-${colKey}`"
                    placeholder="區碼"
                    v-model="form.contact[0]"
                    v-validate="'required'"
                    data-vv-as="區碼"
                    class="form-control form-control-inline form-short"
                    :class="{ 'is-invalid': errors.has(`contact-0-${colKey}`) }"
                    @input="checkInputContact0"
                  />
                  <span class="text">)</span>
                  <input
                    type="tel"
                    maxlength="10"
                    :id="`contact-1-${colKey}`"
                    :data-vv-name="`contact-1-${colKey}`"
                    placeholder="電話號碼"
                    v-model="form.contact[1]"
                    v-validate="'required'"
                    data-vv-as="電話號碼"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`contact-1-${colKey}`) }"
                    @input="checkInputContact1"
                  />
                </div>
              </div>
            </div>
            <!-- 聯絡分機-->
            <div class="col-12">
              <div class="form-group row">
                <label for="contact_tel" class="col-2 text-right">聯絡分機</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="20"
                    :id="`contact_tel-${colKey}`"
                    :data-vv-name="`contact_tel-${colKey}`"
                    placeholder="聯絡分機"
                    v-model="form.contact_tel"
                    v-validate="'required'"
                    data-vv-as="聯絡分機"
                    :class="{ 'is-invalid': errors.has(`contact_tel-${colKey}`) }"
                    class="form-control form-control-inline"
                    @input="checkInputContactTel"
                  />
                </div>
              </div>
            </div>
            <!-- 名單網址 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="description3" class="col-2 text-right">名單網址</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="100"
                    :id="`category_url-${colKey}`"
                    :data-vv-name="`category_url-${colKey}`"
                    v-model="form.category_url"
                    data-vv-as="名單網址"
                    class="form-control"
                    @input="checkInputCategoryUrl"
                  >
                </div>
                <label for="description" class="col-2 text-right"></label>
                <div class="col-10 d-flex text-darkgray">
                  <span>輸入/crm/#/list-area/..的網址</span>
                </div>     
              </div>
            </div>
            <!-- 來源檔案名稱-->
            <div class="col-12">
              <div class="form-group row">
                <label for="src_file_nm" class="col-2 text-right">來源檔案名稱</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="50"
                    :id="`src_file_nm-${colKey}`"
                    :data-vv-name="`src_file_nm-${colKey}`"
                    v-model="form.src_file_nm"
                    data-vv-as="來源檔案名稱"
                    :class="{ 'is-invalid': errors.has(`src_file_nm-${colKey}`) }"
                    class="form-control form-control-inline"
                    @input="checkInputSrcFileName"
                  />
                </div>
              </div>
            </div>
            <!-- 來源檔案欄位名稱-->
            <div class="col-12">
              <div class="form-group row">
                <label for="src_col_nm" class="col-2 text-right">來源檔案欄位名稱</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="100"
                    :id="`src_col_nm-${colKey}`"
                    :data-vv-name="`src_col_nm-${colKey}`"
                    v-model="form.src_col_nm"
                    data-vv-as="來源檔案欄位名稱"
                    :class="{ 'is-invalid': errors.has(`src_col_nm-${colKey}`) }"
                    class="form-control form-control-inline"
                    @input="checkInputSrcColumnName"
                  />
                </div>
              </div>
            </div>
            <!-- 客戶分配方式-->
            <div class="col-12">
              <div class="form-group row">
                <label for="src_alloc_type" class="col-2 text-right">客戶分配方式</label>
                <div class="col-3">
                  <select
                    :id="`src_alloc_type-${colKey}`"
                    :data-vv-name="`src_alloc_type-${colKey}`"
                    data-vv-as="客戶分配方式"
                    class="form-control select-width-2"
                    :class="{ 'is-invalid': errors.has(`src_alloc_type-${colKey}`) }"
                    v-model="form.src_alloc_type"
                  >
                    <option value>請選擇</option>
                    <option
                      v-for="(item, index) in src_alloc_type_opt"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 覆核人員-->
            <div class="col-12">
              <div class="form-group row">
                <label for="approval_name" class="col-2 text-right">覆核人員</label>
                <div class="col-2 d-flex">
                  <label class="f-w-5">{{form.approval_name}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="action text-right">
            <button type="button" @click.stop.prevent="doCancel()" class="btn btn-default">回上頁</button>
            <button type="button" @click.stop.prevent="doPreview(false)" class="btn btn-default">預覽</button>
            <button type="button" @click.stop.prevent="doSubmit(false)" class="btn btn-primary" :disabled="!isModified" v-show="showSubmitBtn">送審</button>
            <button type="button" @click.stop.prevent="doSubmit(true)" class="btn btn-primary" v-show="showApproveBtn">覆核</button>
          </div>
        </section>
      </form>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />

    <!-- 預覽視窗 -->
    <category-preview-modal
      :open="categoryPreviewModalOpen"
      :categoryInfo="categoryData"
      @close="panelClose('categoryPreviewModalOpen')"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { Validator } from "vee-validate";
//component
import TabHeader from "@/desktop/components/backend/TabHeader";
import CategoryPreviewModal from "@/desktop/views/backend/CategoryPreviewModal";
import mxMask from "@/desktop/components/mxMask";
//service
import { callCategoryProcess } from "@/service";
import { callFileUpload } from "@/service";
import { callFileDelete } from "@/service";
export default {
  name: "CategoryEdit",
  mixins: [commonMixin],
  components: { TabHeader, CategoryPreviewModal, mxMask },
  data() {
    return {
      mxMaskOpen: false,
      mxMaskContent: "資料讀取中，請稍候...",
      allCategoryName: [], //所有名單名稱
      categoryOpt: [], //專區大類-下拉選單
      subCategoryOpt: [], //專區中類-下拉選單
      //category: "", //專區大類-自行輸入
      //subcategory: "", //專區中類-自行輸入
      yearOpt_upload: [],
      yearOpt_end: [],
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dateOpt_upload: [],
      dateOpt_end: [],
      src_alloc_type_opt: [
        {value: '1', label: '1.依來源檔指定的業務員及客戶(CRM有客戶資料才顯示)'},
        {value: '2', label: '2.依來源檔的保單號碼分配最新收費人員(CRM有客戶資料才顯示)'},
        {value: '3', label: '3.依來源檔指定的業務員及客戶(CRM不存在也顯示)'}
      ],
      form: {
        ser_no: "", //專區編號
        category: "", //專區大類
        subcategory: "", //專區中類
        category_name: "", //專區名稱
        isquarterly: "", //是否為季辦法
        description: "", //說明1
        description2: "", //說明2
        description3: "", //說明3
        dev_name: "", //維護單位
        contact_tel: "", //維護單位分機
        upload_file: "", //附件名稱
        contact: ["", ""], //維護單位電話
        //subcategory_order: "", //中類排序
        category_name_order: "", //名稱排序
        init_upload_date: "", //專區起日
        upload_date: ["", "", ""], //專區起日
        end_date: ["", "", ""], //專區迄日
        noEndDate: false, //無下架日期
        initCategoryNameOrder: "",//名稱排序初始值
        category_url: "", //名單網址
        src_file_nm: "", //來源檔案名稱
        src_col_nm: "", //來源檔案欄位名稱
        src_alloc_type: "", //客戶分配方式
        input_name: "", //輸入人員
        input_id: "", //輸入人員ID
        approval_name: "", //覆核人員
        approval_status: "", //審核進度
        last_upload_date: "", //前一次覆核日期
      },
      file: {},
      orderCount: "0",
      colKey: "1", //串欄位key用
      initCategoryName: "", //專區名稱初始值
      initUploadFile: "", //附件初始值

      categoryPreviewModalOpen: false,
      categoryData: {}, //整理後的名單資料
      isDelete: false, //是否執行檔案刪除
      isUpload: false, //是否執行檔案上傳
      isUsing: false, //是否為上架中名單
      totalCharacters: 0, //說明1、說明2、說明3輸入的總字數
      overCharacterLimit: false,
      isModified: false,
      isFromSubject: '', // 是否點選名單名稱之連結
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    showSubmitBtn() {
      return this.isFromSubject
    },
    showApproveBtn() {
      return !this.isFromSubject
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    isReadOnlyMode(){
      return !this.isFromSubject && this.form.approval_status == '1'
    },
    changeInput() {
      let vm = this;
      if (!vm.$refs.myFiles.files || vm.$refs.myFiles.files.length == 0) {

        return; //瀏覽檔案點選取消不處理
      }
      vm.file = vm.$refs.myFiles.files[0];
      let fileType = vm.file.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (
        fileType.indexOf("pdf") !== -1 ||
        fileType.indexOf("png") !== -1 ||
        fileType.indexOf("jpeg") !== -1
      ) {
        //檢查檔案大小
        if (vm.$refs.myFiles.files[0].size > 5*1024*1024) {
          vm.setToastMsg("檔案大小不得超過5MB");
          vm.file = {};
          vm.form.upload_file = "";
        } else {
          vm.file = vm.$refs.myFiles.files[0];
          vm.form.upload_file = vm.file.name;
          vm.isUpload = true;
        }
      } else {
        vm.setToastMsg("檔案格式只允許pdf, jpg, png");
        vm.file = {};
        vm.form.upload_file = "";
      }
    },
    //檢查專區大類
    checkInputCategory() {
      this.category = this.category.replace(/\s+/g, ""); //禁止空格
      if (this.stringBytes(this.category, false, 10) > 10) {
        this.category = this.category.substring(
          0,
          this.stringBytes(this.category, true, 10)
        );
      }
    },
    //檢查專區中類
    checkInputSubCategory() {
      this.subcategory = this.subcategory.replace(/\s+/g, ""); //禁止空格
      if (this.stringBytes(this.subcategory, false, 10) > 10) {
        this.subcategory = this.subcategory.substring(
          0,
          this.stringBytes(this.categsubcategoryory, true, 10)
        );
      }
    },
    //檢查專區名稱
    checkInputCategoryName() {
      this.form.category_name = this.form.category_name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\]/g,
        ""
      );
    },
    //檢查說明
    checkInputDescription(inputName) {

      this.form[inputName] = this.form[inputName].replace("\n", ""); //禁止換行

      const prevTotalCharacters = this.totalCharacters
      //更新每個input內容
      this.form[inputName] = this.form[inputName].slice(0, 150 - (this.totalCharacters - this.form[inputName].length) )

      //更新總字數
      this.totalCharacters = this.form.description.length + this.form.description2.length + this.form.description3.length
        
      if(this.totalCharacters > 150){
        this.overCharacterLimit = true;

        this.form[inputName] = this.form[inputName].slice(0, prevTotalCharacters - this.totalCharacters + this.form[inputName].length)

        this.totalCharacters = prevTotalCharacters
      }else{
        this.overCharacterLimit = false;
      }

    },
    //檢查維護單位
    checkInputDevName() {
      this.form.dev_name = this.form.dev_name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },
    //檢查連絡電話
    checkInputContact0() {
      this.form.contact[0] = this.form.contact[0].replace(/[^\d]/g, "");
    },
    checkInputContact1() {
      this.form.contact[1] = this.form.contact[1].replace(/[^\d]/g, "");
    },
    //檢查聯絡分機
    checkInputContactTel() {
      this.form.contact_tel = this.form.contact_tel.replace(/[^\d、~]/g, "");
    },
    //檢查名單網址
    checkInputCategoryUrl() {
      const regex = /^[A-Za-z0-9\u4e00-\u9fa5\/#&=?_-]*$/
      if( !regex.test(this.form.category_url) ){
        this.form.category_url = this.form.category_url.replace(/[^A-Za-z0-9\u4e00-\u9fa5\/#&=?_-]/g,'')
      }
    },
    //檢查來源檔案名稱
    checkInputSrcFileName(){
      this.form.src_file_nm = this.form.src_file_nm.replace(/[^a-zA-Z0-9\u4e00-\u9fa5._]/g, '');
    },
    //檢查來源檔案欄位名稱
    checkInputSrcColumnName(){
      this.form.src_col_nm = this.form.src_col_nm.replace(/[^a-zA-Z0-9\u4e00-\u9fa5,_]/g, '');
    },
    //上下架日期-下拉選單初始化
    updateDate(type, year, month) {
      if (!year || !month) {
        return;
      }
      let dt = new Date(year, month, 0).getDate();
      if (type == "upload") {
        this.dateOpt_upload = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_upload.push(i + 1);
        }
      } else {
        this.dateOpt_end = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_end.push(i + 1);
        }
      }
    },
    markAsEdited() {
      this.isModified = true;
    },
    //檔案刪除
    doDelete() {
      this.form.upload_file = "";
      this.isDelete = true;
      this.isModified = true;
    },
    //取消
    doCancel() {
      this.linkToCategoryView();
    },
    //導頁到名單列表
    linkToCategoryView() {
      this.$router.push({ path: "/backend/tab/1" });
    },
    //整理更新資料
    doFormatData(reconfirm) {
      let errMsg = [];
      this.categoryData = Object.assign({}, this.form);
      this.categoryData.contact =
        "(" + this.form.contact[0] + ")" + this.form.contact[1];

      if (
        this.form.noEndDate ||
        (!this.categoryData.end_date[0] &&
          !this.categoryData.end_date[1] &&
          !this.categoryData.end_date[2])
      ) {
        //無下架日期
        this.categoryData.end_date = "";
      } else if (
        this.categoryData.end_date[0] &&
        this.categoryData.end_date[1] &&
        this.categoryData.end_date[2]
      ) {
        let month =
          this.categoryData.end_date[1].toString().length == 1
            ? "0" + this.categoryData.end_date[1].toString()
            : this.categoryData.end_date[1].toString();
        let date =
          this.categoryData.end_date[2].toString().length == 1
            ? "0" + this.categoryData.end_date[2].toString()
            : this.categoryData.end_date[2].toString();
        this.categoryData.end_date =
          this.form.end_date[0] + "-" + month + "-" + date;
      } else {
        errMsg.push("請確認下架日期是否選取");
      }

      let uploadMonth =
        this.categoryData.upload_date[1].toString().length == 1
          ? "0" + this.categoryData.upload_date[1].toString()
          : this.categoryData.upload_date[1].toString();
      let uploadDate =
        this.categoryData.upload_date[2].toString().length == 1
          ? "0" + this.categoryData.upload_date[2].toString()
          : this.categoryData.upload_date[2].toString();
      this.categoryData.upload_date =
        this.form.upload_date[0] + "-" + uploadMonth + "-" + uploadDate;
      //有下架日期
      if (this.categoryData.end_date) {
        let d_Upload_Date = new Date(this.categoryData.upload_date);
        let d_End_Date = new Date(this.categoryData.end_date);
        if (d_Upload_Date.getTime() > d_End_Date.getTime()) {
          errMsg.push("下架日期不得早於上架日期");
        }
      }

      if(this.initUploadFile && this.form.upload_file && this.initUploadFile == this.form.upload_file && this.isDelete){
        errMsg.push("上傳的檔案名稱不可跟之前的檔名一樣");
      }

      if(!this.categoryData.approval_status){
        if(this.isFromSubject){
          this.categoryData.approval_status = 1
        }else{
          this.categoryData.approval_status = 0
        }
      }else{
        this.categoryData.approval_status = 1
      }

      //是否執行覆核操作
      this.categoryData.reconfirm = reconfirm

      //覆核人員
      this.categoryData.approval_id = this.$store.state.userInfo.id
      this.categoryData.approval_nm = this.$store.state.userInfo.name

      //如果進行覆核操作，輸入人員不會變
      if(this.categoryData.approval_status == 1 && reconfirm){
        this.categoryData.approval_status = 0
      } else {
        // 非覆核操作，如果欄位有異動，輸入人員調整為當前業務員，若無異動則不變
        if(this.isModified){
          this.categoryData.input_id = this.$store.state.userInfo.id
          this.categoryData.input_name = this.$store.state.userInfo.name
        }    
      }
      this.categoryData.last_upload_date = this.form.last_upload_date;

      return errMsg;
    },
    //預覽
    doPreview(reconfirm) {
      this.doFormatData(reconfirm);
      this.categoryPreviewModalOpen = true;
    },
    //確認
    doSubmit(reconfirm) {
      if(this.overCharacterLimit){
        return
      }
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        let errMsg = this.doFormatData(reconfirm);
        if (errMsg && errMsg.length > 0) {
          errMsg.forEach(err => {
            this.$toast.info({ title: err }); //印出檢核後的錯誤訊息
          });
          return;
        }
        //通過檢查，開始更新資料
        this.mxMaskContent = "資料儲存中，請稍候...";
        this.mxMaskOpen = true;

        // //若有刪除檔案，先進行刪檔處理
        // if (this.isDelete && this.initUploadFile) {
        //   callFileDelete(
        //     this.$store.state.userInfo.id,
        //     "1",
        //     this.form.ser_no,
        //     this.initUploadFile
        //   ).then(result => {
        //     this.mxMaskOpen = false; //關閉遮罩
        //     if (result.header && result.header.status == "200") {
        //       //刪除成功，確認是否有需要上傳新檔案
        //       this.mxMaskOpen = true;
        //       if (this.form.upload_file && this.isUpload) {
        //         let vm = this;
        //         callFileUpload(
        //           this.$store.state.userInfo.id,
        //           "1",
        //           this.file,
        //           vm.form.ser_no
        //         ).then(result => {
        //           this.mxMaskOpen = false; //關閉遮罩
        //           if (result.header && result.header.status == "200") {
        //             this.doUpdate();
        //           } else {
        //             this.setToastMsg("儲存失敗，上傳檔案發生異常");
        //             console.error(result.header.message);
        //           }
        //         });
        //       } else {
        //         this.doUpdate();
        //       }
        //     } else {
        //       this.setToastMsg("儲存失敗，刪除檔案發生異常");
        //       console.error(result.header.message);
        //     }
        //   });
        // } else {
        //   //沒有刪除檔案，檢查是否有檔案上傳
        //   if (this.form.upload_file && this.isUpload) {
        //     let vm = this;
        //     callFileUpload(
        //       this.$store.state.userInfo.id,
        //       "1",
        //       this.file,
        //       vm.form.ser_no
        //     ).then(result => {
        //       this.mxMaskOpen = false; //關閉遮罩
        //       if (result.header && result.header.status == "200") {
        //         this.doUpdate();
        //       } else {
        //         this.setToastMsg("儲存失敗，上傳檔案發生異常");
        //         console.error(result.header.message);
        //       }
        //     });
        //   } else {
        //     this.doUpdate();
        //   }
        // }
        // 檔案有 新增 或 異動更新 就上傳
        if ( (this.isUpload && this.form.upload_file) || (this.form.upload_file && this.initUploadFile && this.form.upload_file !== this.initUploadFile)) {
          let vm = this;
          callFileUpload(
            this.$store.state.userInfo.id,
            "1",
            this.file,
            vm.form.ser_no
          ).then(result => {
            this.mxMaskOpen = false; //關閉遮罩
            if (result.header && result.header.status == "200") {
              this.doUpdate();
            } else {
              this.setToastMsg("儲存失敗，上傳檔案發生異常");
              console.error(result.header.message);
            }
          });
        } else {
          this.doUpdate();
        }
      });
    },

    //資料更新
    doUpdate() {
      this.mxMaskOpen = true;
      callCategoryProcess(
        this.$store.state.userInfo.id,
        "2",
        this.categoryData
      ).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        if (res.header && res.header.status === "200") {
          this.$toast.info({ title: "編輯名單成功" });
          this.linkToCategoryView();
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }
      });
    },

    //初始化
    init() {
      this.categoryOpt = this.$route.params.categoryData || []; //專區大類-下拉選單
      this.allCategoryName = this.$route.params.allCategoryName || []; //所有名單名稱
      let categoryInfo = this.$route.params.categoryInfo || "";
      this.isFromSubject = this.$route.params.isFromSubject
      
      if (!categoryInfo) {
        //無資料則回到名單列表
        this.linkToCategoryView();
        return;
      }

      this.form.ser_no = categoryInfo.ser_no; //專區編號
      this.form.input_name = categoryInfo.input_nm || ""; //輸入人員
      this.form.input_id = categoryInfo.input_id || ""; //輸入人員ID
      this.form.category = categoryInfo.category || ""; //專區大類
      this.form.subcategory = categoryInfo.subcategory || ""; //專區中類
      this.initCategoryName = categoryInfo.category_name || ""; //專區名稱初始值
      this.form.category_name = categoryInfo.category_name || ""; //專區名稱
      this.form.isquarterly = categoryInfo.isquarterly || ""; //是否為季辦法

      this.form.dev_name = categoryInfo.dev_name || ""; //維護單位
      this.form.contact_tel = categoryInfo.contact_tel || ""; //維護單位分機
      this.initUploadFile = categoryInfo.upload_file || ""; //附件初始值
      this.form.upload_file = categoryInfo.upload_file || ""; //附件名稱

      this.form.description = categoryInfo.description || ""; //說明1
      this.form.description2 = categoryInfo.description2 || ""; //說明2
      this.form.description3 = categoryInfo.description3 || ""; //說明3
      this.form.category_url = categoryInfo.url || ""; //名單網址
      this.form.src_file_nm = categoryInfo.src_file_nm || ""; //來源檔案名稱
      this.form.src_col_nm = categoryInfo.src_col_nm || ""; //來源檔案欄位名稱
      this.form.src_alloc_type = categoryInfo.src_alloc_type || ""; //客戶分配方式
      this.form.approval_name = categoryInfo.approval_nm || ""; //覆核人員
      this.form.approval_status = categoryInfo.approval_status || ""; //審核進度
      this.form.last_upload_date = categoryInfo.last_upload_date || ""; // 上次覆核日
      let contact = categoryInfo.contact || ""; //維護單位電話
      let leftIndex = contact.indexOf("(");
      let rightIndex = contact.indexOf(")");
      if (contact) {
        if (leftIndex !== -1 && rightIndex !== -1) {
          let splitleft = contact.split("(");
          let splitRight = splitleft[1].split(")");
          this.form.contact[0] = splitRight[0] || "";
          this.form.contact[1] = splitRight[1] || "";
        } else if (contact.indexOf("-") !== -1) {
          let splitDash = contact.split("-");
          this.form.contact[0] = splitDash[0] || "";
          this.form.contact[1] = splitDash[1] || "";
        }
      }

      //上架日期 (專區起日)
      let upload_date = categoryInfo.upload_date || ""; //上架日期
      this.form.init_upload_date = categoryInfo.upload_date || ""; //原本的上架日期
      if (upload_date) {
        let upload_dateArr = upload_date.split("-");
        this.form.upload_date[0] = upload_dateArr[0]; //年
        if (parseInt(upload_dateArr[1]) > 9) {
          this.form.upload_date[1] = upload_dateArr[1]; //月
        } else {
          this.form.upload_date[1] = upload_dateArr[1].replace("0", ""); //月 (去除0)
        }
        if (parseInt(upload_dateArr[2]) > 9) {
          this.form.upload_date[2] = upload_dateArr[2]; //日
        } else {
          this.form.upload_date[2] = upload_dateArr[2].replace("0", ""); //日 (去除0)
        }
      }
      //下架日期 (專區迄日)
      let end_date = categoryInfo.end_date || "";
      if (end_date) {
        let end_dateArr = end_date.split("-");
        this.form.end_date[0] = end_dateArr[0]; //年
        if (parseInt(end_dateArr[1]) > 9) {
          this.form.end_date[1] = end_dateArr[1]; //月
        } else {
          this.form.end_date[1] = end_dateArr[1].replace("0", ""); //月 (去除0)
        }
        if (parseInt(end_dateArr[2]) > 9) {
          this.form.end_date[2] = end_dateArr[2]; //日
        } else {
          this.form.end_date[2] = end_dateArr[2].replace("0", ""); //日 (去除0)
        }
      } else {
        this.form.noEndDate = true; //無下架日期
      }
      this.form.initCategoryNameOrder = categoryInfo.category_name_order || ""; //名稱排序初始值
      this.form.category_name_order = categoryInfo.category_name_order || ""; //名稱排序

      //查詢特定專區中類底下的名單筆數
      this.mxMaskOpen = true;
      callCategoryProcess(
        this.$store.state.userInfo.id,
        "3",
        this.form.subcategory
      ).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        if (res.header && res.header.status === "200") {
          let isUsingCategoryList = res.body.isusingcategorylist || [];
          this.orderCount = isUsingCategoryList.length || "0";
          for (let i = 0; i < isUsingCategoryList.length; i++) {
            if (
              isUsingCategoryList[i].ser_no == this.form.ser_no &&
              isUsingCategoryList[i].upload_date == this.form.init_upload_date
            ) {
              this.isUsing = true; //只允許上架中名單調整名單次序
              break;
            }
          }
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }
      });

      this.initSubcategoryOpt(true);
      this.initDateOption();
    },
    //重取專區中類選項
    initSubcategoryOpt(isInit) {
      if (!this.form.category) {
        return;
      }
      this.mxMaskContent = "資料讀取中，請稍候...";
      this.mxMaskOpen = true;
      callCategoryProcess(
        this.$store.state.userInfo.id,
        "5",
        this.form.category
      ).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        if (res.header && res.header.status === "200") {
          this.subCategoryOpt = res.body.subcategorylist || [];
          if (!isInit) {
            this.form.subcategory = ""; //編輯中切換大類, 中類變成請選擇
          }
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }
      });
    },
    //重取專區中類底下的名單筆數
    initOrderOpt() {
      if (!this.isUsing) {
        return; //已下架名單不觸發重取下拉選項
      }
      this.mxMaskContent = "資料讀取中，請稍候...";
      this.mxMaskOpen = true;
      callCategoryProcess(
        this.$store.state.userInfo.id,
        "3",
        this.form.subcategory
      ).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        if (res.header && res.header.status === "200") {
          let isUsingCategoryList = res.body.isusingcategorylist || [];
          this.orderCount = isUsingCategoryList.length || "0";
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }
      });
    },
    //檢核規則初始化
    initValidator() {
      //檢查名單名稱是否與其他名單重複
      Validator.extend("checkCategoryNameIsExist", {
        getMessage: "此名單名稱已經存在",
        validate: value => {
          let cnt = 0;
          if (value !== this.initCategoryName) {
            //名單名稱不為初始值時才去檢查
            for (let i = 0; i < this.allCategoryName.length; i++) {
              if (value == this.allCategoryName[i]) {
                cnt++;
              }
            }
          }
          return cnt < 1;
        }
      });
      //檢查名單名稱是否大於24個字元
      Validator.extend("checkCategoryNameSize", {
        getMessage: "名單名稱不得大於24個字元",
        validate: value => {
          return !(this.stringBytes(value, false, 24) > 24);
        }
      });
    },
    //日期下拉選單初始化
    initDateOption() {
      let thisYear = window.moment().year(); //今年
      //上架日期
      if (this.form.upload_date[0]) {
        let uploadYear = parseInt(this.form.upload_date[0]);
        for (let s = uploadYear - 2; s <= uploadYear + 2; s++) {
          this.yearOpt_upload.push(s);
        }
      } else {
        for (let s = thisYear - 2; s <= thisYear + 2; s++) {
          this.yearOpt_upload.push(s);
        }
      }
      //下架日期
      if (this.form.end_date[0]) {
        let endYear = parseInt(this.form.end_date[0]);
        for (let s = endYear - 2; s <= endYear + 2; s++) {
          this.yearOpt_end.push(s);
        }
      } else {
        for (let s = thisYear - 2; s <= thisYear + 2; s++) {
          this.yearOpt_end.push(s);
        }
      }
      this.updateDate(
        "upload",
        this.form.upload_date[0],
        this.form.upload_date[1]
      );
      this.updateDate("end", this.form.end_date[0], this.form.end_date[1]);
    }
  },
  mounted() {
    this.init();
    this.initValidator();
    this.registerHanlink();
  }
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid orange;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.select-width {
  width: 150px;
}

.select-width-2 {
  width: 500px;
}

.span-margin-top {
  margin-top: 12px;
}

.text-darkgray{
  color: #6C6C6C !important;
}

.f-w-5 {
  font-weight: 500;
}

.readonly-mode {
  pointer-events: none; /* 禁用點擊 */
}
.readonly-mode input,
.readonly-mode select,
.readonly-mode .radio,
.readonly-mode .delete-btn {
  pointer-events: none;
  filter: grayscale(100%);
  background-color: #f5f5f5 !important; 
  color: #999 !important;
  border-color: #ccc !important;
  cursor: not-allowed; 
}
</style>
